//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TitleBox from '@/components/TitleBox';
import MiniNavBar from '@/components/MiniNavBar.vue';
export default {
    components: { TitleBox, MiniNavBar },
    data() {
        return {
            currentItem: 0,
            actList: [],
            newsList: [],
            recommendList: [],
            typeList: []
        };
    },
    computed: {
        transX() {
            return this.currentItem * -100 + '%';
        }
    },
    mounted() {
        this.getTypes();
        this.getActList();
        this.getNewsList(1).then(() => {
            this.initNews();
        });
        this.getNewsList();
    },
    methods: {
        initNews() {
            new window.Swiper('#news', {
                // 循环模式选项
                loop: true,
                /* autoplay: {
                    disableOnInteraction: false
                }, */
                effect: 'fade',
                pagination: {
                    el: '#news .swiper-pagination'
                }
            });
        },
        getTypes() {
            this.axios({
                method: 'post',
                url: '/articleCategory/list',
                data: {
                    pid: 2
                }
            }).then(res => {
                if (res.code === 0) {
                    this.typeList = res.data;
                }
            });
        },
        getActList() {
            return this.axios({
                method: 'post',
                url: '/article/listPage',
                data: {
                    categoryId: '54',
                    pageNum: 1,
                    pageSize: 100,
                    language: this.i18n
                }
            }).then(res => {
                if (res.code === 0) {
                    this.actList = res.data.data;
                }
            });
        },
        getNewsList(recommend = 0) {
            return this.axios({
                method: 'post',
                url: '/article/listPage',
                data: {
                    categoryId: '55',
                    recommend: recommend,
                    pageNum: 1,
                    pageSize: 100,
                    language: this.i18n
                }
            }).then(res => {
                if (res.code === 0) {
                    if (recommend) {
                        this.recommendList = res.data.data;
                    } else {
                        this.newsList = res.data.data;
                    }
                }
            });
        }
    }
};
